import { render, staticRenderFns } from "./SzNc.vue?vue&type=template&id=42413965&scoped=true&"
import script from "./SzNc.vue?vue&type=script&lang=js&"
export * from "./SzNc.vue?vue&type=script&lang=js&"
import style0 from "./SzNc.vue?vue&type=style&index=0&id=42413965&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42413965",
  null
  
)

export default component.exports